import React from 'react';
import StartNow from '../../../Common-components/start-now/StartNow';
import "./Solutions.css";
import background from '../../Assets/background_images/background3.png';

const CognitiveQuotient = () => {
    return (
        <div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'>Cognitive Quotient</div>
        </div>
 
     <div> 
       <h1 className='title'>WHAT IS THE CQ?</h1> 
       <p className='paragraph'>The CQ assesses a participant's capacity to solve work-related challenges by asking the following questions:</p>
       <ul className='outer-list'>
            <li>Linguistic Comprehension - Assesses English language abilities by looking at word meanings and relationships.</li>
            <li>Quantitative Skills - Assesses the ability to complete calculations accurately using addition, subtraction, multiplication, and division.</li>
            <li>Spatial Skills — Assesses problem-solving abilities, pattern identification, and 2D and 3D object manipulation.</li>
        </ul>
        <p className='paragraph'>Once finished, a report is provided that includes information about a candidate's strengths, recommendations on areas for improvement, training tips, and suggested interview questions.</p>
     </div> 
     <hr />

     <div> 
       <h1 className='title'>BENEFITS OF USING THE CQ?</h1> 
       <p className='paragraph'>You may do the following with CQ integrated into your hiring and training operations:</p>
       <ul className='outer-list'>
           <li>Determine the specific training requirements of possible new hires and present staff.</li>
           <li>Match a person's skills to relevant job tasks.</li>
           <li>Using personalized interview questions, you can expedite the interview process.</li>
       </ul>
     </div> 
     <hr />

     <div> 
       <h1 className='title'>THE DETAILS</h1> 
       <p className='paragraph'>The assessment can be completed online using a web browser on a computer or mobile device anywhere clients have internet connection (for example, at home, at workplaces, or on client premises).</p>
       <p className='paragraph'>The evaluation takes about 25-30 minutes to complete, however there is no time constraint. Participants are asked to respond to evaluation questions based on their immediate impression rather than overthinking how to answer.</p>
       <p className='paragraph'>Strategic Links automatically processes responses and generates a PDF report, which is then delivered to designated parties within one hour of the survey's completion. Reports are also available by checking in to our Strategic Links evaluation portal with your own personal login information.</p>
     </div> 


     <div style={{textAlign:'center'}}>
       <StartNow/>
     </div>
     </div>
    )
}
 
export default CognitiveQuotient;